import { render, staticRenderFns } from "./ChatMarkdown.vue?vue&type=template&id=7329fbd8&scoped=true"
import script from "./ChatMarkdown.vue?vue&type=script&lang=ts"
export * from "./ChatMarkdown.vue?vue&type=script&lang=ts"
import style0 from "./ChatMarkdown.vue?vue&type=style&index=0&id=7329fbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7329fbd8",
  null
  
)

export default component.exports